export default __webpack_public_path__ + "static/media/hullbreaker.f1d2d5ee.png";